import { Typography } from '../../../designComponents';
import { FooterSectionStyled } from '../style';

type Menu = {
  label: string;
}[];

const generalMenu: Menu = [
  {
    label: 'CAD Conversion',
  },
  {
    label: 'Approval Workflow',
  },
  {
    label: 'Printing Services',
  },
  {
    label: 'Secure Payments',
  },
];

const Services = () => {
  return (
    <FooterSectionStyled>
      <Typography fontColor="white" className="title">
        SERVICES
      </Typography>
      {generalMenu?.map((menu, index) => {
        return (
          <div key={index} className="menu">
            <Typography fontColor="white" className="menu-item">
              {menu?.label}
            </Typography>
          </div>
        );
      })}
    </FooterSectionStyled>
  );
};

export default Services;
